<template>
  <cart-empty v-if="items.length == 0" />
  <div v-else class="cart-container">
    <item-cart
      v-for="(item, index) in items"
      :item="item"
      :key="index"
      @onRemove="$store.dispatch('cart/removeFromCart', index)"
    />
    <div class="recipient-container">
      <span class="title">Recipient Details</span>
      <span class="message">Our e-gift card will be delivery via text message</span>
      <div class="radio-option normal-button" @click="toggleMe" key="me">
        <img
          v-if="currentInfo == 'me'"
          src="@/assets/radioactive.png"
          style="widht: 25px; height: 25px;"
        />
        <img v-else src="@/assets/radioinactive.png" style="widht: 25px; height: 25px;" />
        <span class="radio-title ml15">This is for me</span>
      </div>
      <div v-if="currentInfo == 'me'">
        <PhoneInput
          @input="myPhoneInput"
          :error="errorMyPhone"
          placeholder="Your Phone Number"
          key="my-phone"
        />
      </div>
      <div class="radio-option normal-button" @click="toggleGift" key="gift">
        <img
          v-if="currentInfo == 'gift'"
          src="@/assets/radioactive.png"
          style="widht: 25px; height: 25px;"
        />
        <img v-else src="@/assets/radioinactive.png" style="widht: 25px; height: 25px;" />
        <span class="radio-title ml15">This is a gift</span>
      </div>
      <div v-if="currentInfo == 'gift'">
        <PhoneInput
          @input="recipientPhoneInput"
          :error="errorRePhone"
          placeholder="Recipient Phone Number"
          key="recipient-phone"
          id="recipient-phone"
        />
        <text-field
          placeholder="Recipient Name"
          v-model="recipientName.val"
          :error="recipientName.error"
          key="recipientName"
        />
        <text-field
          placeholder="Sender Name"
          v-model="senderName.val"
          :error="senderName.error"
          key="senderName"
        />
        <PhoneInput
          key="sender-phone"
          id="sender-phone"
          @input="senderPhoneInput"
          :error="errorSePhone"
          placeholder="Sender Phone Number (optional)"
        />
        <div class="box-input">
          <textarea
            maxlength="160"
            v-model="message.val"
            placeholder="Message (optional)"
            class="input"
          />
          <span class="input-count">{{message.val.length}}/160</span>
        </div>
      </div>
    </div>
    <div class="checkout-bottom">
      <div class="checkout-info">
        <span class="text">Total</span>
        <span class="text">${{totalAmount}}</span>
      </div>
      <gradient-button class="mt30" title="Buy now" @onClick="gotoPayment" />
    </div>
    <transition name="fade">
      <div v-if="toggleBottom" class="overlay" @click="toggleBottom = false" />
    </transition>
    <transition name="slide">
      <confirm-alert
        v-if="toggleBottom"
        class="confirm-alert"
        :phoneNumber="phoneNumber"
        @onConfirmed="onConfirmed"
      />
    </transition>
  </div>
</template>
<script>
import GradientButton from "@/components/GradientButton";
import { mapGetters } from "vuex";
import CartEmpty from "./components/CartEmpty";
import ItemCart from "./components/ItemCart";
import TextField from "@/components/TextField";
import PhoneInput from "@/components/PhoneInput";
import ConfirmAlert from "@/components/ConfirmAlert";

export default {
  name: "Cart",
  components: {
    CartEmpty,
    ItemCart,
    TextField,
    GradientButton,
    PhoneInput,
    ConfirmAlert
  },
  data() {
    return {
      toggleBottom: false,
      errorMyPhone: "",
      errorRePhone: "",
      errorSePhone: "",
      currentInfo: "me",
      myPhone: {
        number: { input: "" }
      },
      recipientPhone: {
        number: { input: "" }
      },
      recipientName: {
        val: "",
        error: ""
      },
      senderName: {
        val: "",
        error: ""
      },
      senderPhone: {
        number: { input: "" }
      },
      message: {
        val: "",
        error: ""
      },
      paypalEnv: process.env.VUE_APP_PAYPAL_ENV,
      paypalClient: {
        [process.env.VUE_APP_PAYPAL_ENV]: process.env.VUE_APP_PAYPAL_CLIENT_ID
      },
      paypalStyle: {
        label: "pay",
        size: "large",
        shape: "pill",
        color: "gold",
        tagline: false
      }
    };
  },
  computed: {
    ...mapGetters(["items"]),
    current() {
      return this.currentInfo;
    },
    totalAmount() {
      let amount = 0;
      const items = this.$store.state.cart.items;
      items.forEach(item => {
        amount += item.egift_amount;
      });
      return amount;
    },
    reName() {
      return this.recipientName.val;
    },
    seName() {
      return this.senderName.val;
    },
    myPhoneInput() {
      const self = this;
      return (val, obj) => {
        if (obj.valid) {
          self.errorMyPhone = "";
        }
        self.myPhone = obj;
      };
    },
    recipientPhoneInput() {
      const self = this;
      return (val, obj) => {
        if (obj.valid) {
          self.errorRePhone = "";
        }
        self.recipientPhone = obj;
      };
    },
    senderPhoneInput() {
      const self = this;
      return (val, obj) => {
        if (obj.valid) {
          self.errorSePhone = "";
        }
        self.senderPhone = obj;
      };
    },
    phoneNumber() {
      return this.currentInfo == "me"
        ? this.myPhone.number.international
        : this.recipientPhone.number.international;
    }
  },
  methods: {
    onConfirmed() {
      this.toggleBottom = false;
      this.$router.push("/payment");
    },
    gotoPayment() {
      const emptyError = "This field can not be empty";
      const invalidPhoneError = "Invalid phone number";
      if (this.currentInfo == "me") {
        if (this.myPhone.number.input == "") {
          this.errorMyPhone = emptyError;
          return;
        } else if (!this.myPhone.valid) {
          this.errorMyPhone = invalidPhoneError;
          return;
        }
      } else if (this.currentInfo == "gift") {
        let error = false;
        if (this.recipientPhone.number.input == "") {
          error = true;
          this.errorRePhone = emptyError;
        } else if (!this.recipientPhone.valid) {
          error = true;
          this.errorRePhone = invalidPhoneError;
        }
        if (this.senderName.val.trim() == "") {
          this.senderName.error = emptyError;
          error = true;
        }
        if (this.recipientName.val.trim() == "") {
          this.recipientName.error = emptyError;
          error = true;
        }
        if (this.senderPhone.number.input != "" && !this.senderPhone.valid) {
          this.errorSePhone = invalidPhoneError;
          error = true;
        }
        if (error) {
          return;
        }
      }

      const phone =
        this.currentInfo == "me"
          ? this.myPhone.number.e164
          : this.recipientPhone.number.e164;

      const phoneVal =
        this.currentInfo == "me"
          ? this.myPhone.number.international
          : this.recipientPhone.number.international;

      const data = {
        recipient_phone_number: phone,
        recipient_name: this.currentInfo == "me" ? "" : this.recipientName.val,
        sender_name: this.currentInfo == "me" ? "" : this.senderName.val,
        sender_phone_number:
          this.currentInfo == "me" ? "" : this.senderPhone.number.e164,
        message: this.currentInfo == "me" ? "" : this.message.val,
        phoneVal
      };
      this.$store.dispatch("cart/setPaymentInfo", data);
      this.toggleBottom = true;
    },
    toggleGift() {
      this.currentInfo = "gift";
    },
    toggleMe() {
      this.currentInfo = "me";
    },
    paypalAuthorized: res => {
      console.log(res);
    },
    paypalCancelled: res => {
      console.log(res);
    }
  },
  watch: {
    seName: function(str) {
      if (this.senderName.error != "" && str != "") {
        this.senderName.error = "";
      }
    },
    reName: function(str) {
      if (this.recipientName.error != "" && str != "") {
        this.recipientName.error = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(295px);
}
.cart-container {
  display: flex;
  flex-direction: column;
  padding-left: 70px;
  padding-right: 70px;
  min-height: calc(100vh - 50px);
  background-color: white;
  .recipient-container {
    display: flex;
    flex-direction: column;
    margin: 40px 10px 200px 10px;
    .title {
      font-family: "SFProText-Bold", -apple-system;
      font-weight: bold;
      font-size: 20px;
    }
    .message {
      font-size: 14px;
      margin-top: 10px;
      color: #b40309;
    }
    .radio-option {
      display: flex;
      align-items: center;
      padding: 20px 0;
      .radio-title {
        font-family: "SFProText-Semibold", -apple-system;
        font-weight: 600;
        font-size: 16px;
      }
    }
    .box-input {
      border-radius: 5px;
      border: 1px solid #eeeeee;
      background-color: #fafafa;
      padding: 15px 0 10px 0;
      display: flex;
      flex-direction: column;
      .input {
        width: 100%;
        height: 60px;
        font-size: 16px;
        font-family: "SFProText-Medium" -apple-system;
        font-weight: 500;
        outline: none;
        outline-style: none;
        padding: 0 20px;
        box-shadow: none;
        border: 0;
        resize: none;
        background-color: #fafafa;
      }
      .input-count {
        align-self: flex-end;
        font-family: "SFProText-Semibold" -apple-system;
        font-weight: 600;
        color: #696969;
        font-size: 14px;
        margin-right: 15px;
      }
    }
  }
  .confirm-alert {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 4;
  }
  .overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }
  .checkout-disable {
    position: fixed;
    bottom: 0;
    left: calc(50% - 300px);
    right: calc(50% - 300px);
    height: 152px;
  }
  .checkout-bottom {
    position: fixed;
    bottom: 0;
    left: calc(50% - 300px);
    right: calc(50% - 300px);
    display: flex;
    flex-direction: column;
    background-color: white;
    padding: 20px 70px 30px 70px;
    .checkout-info {
      display: flex;
      justify-content: space-between;
      .text {
        font-size: 24px;
        font-family: "SFProText-Bold", -apple-system;
        font-weight: bold;
      }
    }
    .btn-paypal {
      margin-top: 30px;
      align-self: center;
    }
  }
}
@media only screen and (max-width: 600px) {
  .cart-container {
    padding-left: 0;
    padding-right: 0;
    .checkout-bottom {
      left: 0;
      right: 0;
      padding: 20px 20px 30px 20px;
    }
    .checkout-disable {
      left: 0;
      right: 0;
    }
    .input {
      height: 65px;
    }
  }
}
</style>